import { chakra, FormLabel, useMultiStyleConfig } from "@chakra-ui/react";

export const LoadingSelectForm = ({ label }: { label: string }) => {
  const styles = useMultiStyleConfig("SuiSelect", {});
  const height = styles.field?.h || styles.field?.height;
  const buttonStyles: any = {
    fontWeight: "normal",
    textAlign: "left",
    color: "inherit",
    minH: height,
    minW: 0,
    ...styles.field,
    h: "auto",
    display: "inline-flex",
    alignItems: "center",
    backgroundColor: "rgb(243, 244, 246)",
    borderColor: "rgb(243, 244, 246)",
    animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
  };
  return (
    <div>
      <FormLabel>{label}</FormLabel>
      <chakra.div
        sx={{
          ...buttonStyles,
        }}
      ></chakra.div>
    </div>
  );
};
